import { StaticPage } from './StaticPage'

export function AcceptableUsePage() {
  return (
    <StaticPage
      title="Pravila sprejemljive uporabe"
      description="Kaj na Fukodromu ni dovoljeno: spam, zlorabe, nevarna navodila, doxxing in obhajanje omejitev."
      path="/acceptable-use"
      eyebrow="Safety"
    >
      <ul>
        <li>Ne objavljaj zasebnih naslovov, osebnih podatkov ali lokacij, ki bi lahko koga ogrozile.</li>
        <li>Ne objavljaj spama, phishinga, malware povezav ali zlonamerne avtomatizacije.</li>
        <li>Ne obhajaj rate limitov, prijavnih zaščit ali moderatorskih omejitev.</li>
        <li>Ne objavljaj nevarnih, nezakonitih ali zavajajočih navodil za dostop.</li>
        <li>Ne nadleguj drugih uporabnikov in ne zlorabljaj sistema prijav.</li>
      </ul>
      <p>
        Kršitve lahko vodijo do odstranitve vsebine, omejitve računa ali trajne blokade.
      </p>
    </StaticPage>
  )
}
